module.exports = __webpack_public_path__ + "static/img/loginBackground.957bfa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loginBackground.png
// module id = hsMe
// module chunks = 1